var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ask-mobile-popover", {
        attrs: { mobile: _vm.mobile, "is-open": _vm.openPopover },
        on: { done: _vm.updateMobile },
      }),
      _vm._v(" "),
      _c("iframe", {
        staticClass: "radius-5 no-overflow",
        attrs: {
          id: "fbFrame",
          src: "https://app.eatself.com/dist/fb-button.html",
          xsrc: "http://localhost/eatself/dist/fb-button.html",
          frameborder: "0",
          width: "100%",
          height: "103px",
        },
      }),
      _vm._v(" "),
      _vm.LoginStatus
        ? _c(
            "p",
            {
              staticClass: "text-danger text-center",
              on: {
                click: function ($event) {
                  _vm.openPopover = !_vm.openPopover
                },
              },
            },
            [_vm._v(_vm._s(_vm.LoginStatus))]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }